//Kerala Images
import kerala1 from "./DomImages/kerala/kerala1.png";
import kerala2 from "./DomImages/kerala/kerala2.png";
import kerala3 from "./DomImages/kerala/kerala3.png";

//Rajasthan Images
import rajasthan1 from "./DomImages/rajasthan/rajasthan1.png";
import rajasthan2 from "./DomImages/rajasthan/rajasthan2.png";
import rajasthan3 from "./DomImages/rajasthan/rajasthan3.png";
import rajasthan4 from "./DomImages/rajasthan/rajasthan4.png";

//Chardham Images
import chardham1 from "./DomImages/chardham/chardham1.png";
import chardham2 from "./DomImages/chardham/chardham2.png";
import chardham3 from "./DomImages/chardham/chardham3.png";
import chardham4 from "./DomImages/chardham/chardham4.png";

//Kashmir Images
import kashmir1 from "./DomImages/kashmir/kashmir1.png";
import kashmir2 from "./DomImages/kashmir/kashmir2.png";
import kashmir3 from "./DomImages/kashmir/kashmir3.png";
import kashmir4 from "./DomImages/kashmir/kashmir4.png";
import amritsar1 from "./DomImages/kashmir/amrit1.png";

//Golden Triangle Images
import golden1 from "./DomImages/goldenT/golden1.png";
import golden2 from "./DomImages/goldenT/golden2.png";
import golden3 from "./DomImages/goldenT/golden3.png";
import golden4 from "./DomImages/goldenT/golden4.png";
import golden5 from "./DomImages/goldenT/golden5.png";
import golden6 from "./DomImages/goldenT/golden6.png";
import golden7 from "./DomImages/goldenT/golden7.png";
import golden8 from "./DomImages/goldenT/golden8.png";

//Tamil Nadu Images
import tamil5 from "./DomImages/tamilnadu/tamil5.png";
import tamil2 from "./DomImages/tamilnadu/tamil2.png";
import tamil3 from "./DomImages/tamilnadu/tamil3.png";
import tamil4 from "./DomImages/tamilnadu/tamil4.png";
import tamil6 from "./DomImages/tamilnadu/tamil6.png";

//Andaman Images
import andaman1 from "./DomImages/andaman/andaman1.png";
import andaman2 from "./DomImages/andaman/andaman2.png";
import andaman3 from "./DomImages/andaman/andaman3.png";

//Lakshadweep Images
import ld1 from "./DomImages/lakshdweep/ld1.png";
import ld2 from "./DomImages/lakshdweep/ld2.png";

//Gujarat Images
import gujarat1 from "./DomImages/gujarat/gujarat1.png";
import gujarat2 from "./DomImages/gujarat/gujarat2.png";
import gujarat3 from "./DomImages/gujarat/gujarat3.png";
import gujarat4 from "./DomImages/gujarat/gujarat4.png";
import gujarat5 from "./DomImages/gujarat/gujarat5.png";
import gujarat6 from "./DomImages/gujarat/gujarat6.png";
import gujarat7 from "./DomImages/gujarat/gujarat7.png";

//Goa Images
import goa1 from "./DomImages/goa/goa1.png";
import goa2 from "./DomImages/goa/goa2.png";
import goa3 from "./DomImages/goa/goa3.png";
import goa4 from "./DomImages/goa/goa4.png";
import goa5 from "./DomImages/goa/goa5.png";

//Shimla-Manali Images
import shimla1 from "./DomImages/shimla/shimla1.png";
import shimla2 from "./DomImages/shimla/shimla2.png";
import shimla3 from "./DomImages/shimla/shimla3.png";
import shimla4 from "./DomImages/shimla/shimla4.png";
import shimla5 from "./DomImages/shimla/shimla5.png";

//Varanasi-Ayodhya Images
import varanasi1 from "./DomImages/varanasi/varanasi1.png";
import varanasi2 from "./DomImages/varanasi/varanasi2.png";
import varanasi3 from "./DomImages/varanasi/varanasi3.png";

//Mahabaleshwar & Lonavala Images
import lonavala1 from "./DomImages/lonavala/lonavala1.png";
import lonavala2 from "./DomImages/lonavala/lonavala2.png";
import lonavala3 from "./DomImages/lonavala/lonavala3.png";
import lonavala4 from "./DomImages/lonavala/lonavala4.png";

//Sikkim Images
import sikkim1 from "./DomImages/sikkim/sikkim1.png";
import sikkim2 from "./DomImages/sikkim/sikkim2.png";
import sikkim3 from "./DomImages/sikkim/sikkim3.png";
import sikkim4 from "./DomImages/sikkim/sikkim4.png";
import sikkim5 from "./DomImages/sikkim/sikkim5.png";

//Karnataka Images
import kar1 from "./DomImages/karnataka/kar1.png";
import kar2 from "./DomImages/karnataka/kar2.png";
import kar3 from "./DomImages/karnataka/kar3.png";
import kar4 from "./DomImages/karnataka/kar4.png";
import kar5 from "./DomImages/karnataka/kar5.png";
import kar6 from "./DomImages/karnataka/kar6.png";
import kar7 from "./DomImages/karnataka/kar7.png";
import kar8 from "./DomImages/karnataka/kar8.png";
import kar9 from "./DomImages/karnataka/kar9.png";
import kar10 from "./DomImages/karnataka/kar10.png";
import kar11 from "./DomImages/karnataka/kar11.png";
import kar12 from "./DomImages/karnataka/kar12.png";

//Meghalaya
import megh1 from "./DomImages/meghalaya/megh1.png";
import megh2 from "./DomImages/meghalaya/megh2.png";
import megh3 from "./DomImages/meghalaya/megh3.png";
import megh4 from "./DomImages/meghalaya/megh4.png";

//Arunachal Prdaesh
import arunachal1 from "./DomImages/arunachal/arunachal1.png";
import arunachal2 from "./DomImages/arunachal/arunachal2.png";
import arunachal3 from "./DomImages/arunachal/arunachal3.png";
import arunachal4 from "./DomImages/arunachal/arunachal4.png";

//Mussoorie
import mussoorie1 from "./DomImages/mussoorie/mussoorie1.png";
import mussoorie2 from "./DomImages/mussoorie/mussoorie2.jpg";
import mussoorie3 from "./DomImages/mussoorie/mussoorie3.jpg";
import mussoorie4 from "./DomImages/mussoorie/mussoorie4.png";
import mussoorie5 from "./DomImages/mussoorie/mussoorie5.png";

const domestic = [
  // Kerala 5N/6D Tour
  {
    id: 1,
    title: "Kerala Backwaters",
    subtitle: "Kochi - Munnar - Thekkady - Alleppey - Kollam",
    image: kerala2,
    images: [kerala1, kerala2, kerala3],
    overview:
      "Kerala tour offers a perfect blend of serene backwaters, lush hill stations, pristine beaches, and rich cultural heritage. Cruise through the famous Alleppey and Kumarakom backwaters on a traditional houseboat. Explore misty hill stations like Munnar, known for tea plantations and breathtaking landscapes. Relax on beautiful beaches such as Kovalam and Varkala along the Arabian Sea. Experience vibrant traditions including Kathakali dance, Ayurveda therapies, and local festivals. Savor authentic Kerala cuisine, featuring fresh seafood, coconut flavors, and aromatic spices.",
    duration: "5 Nights / 6 Days",
    itinerary: [
      {
        day: "01",
        title: "KOCHI AIRPORT TO MUNNAR HOTEL (130KM / 04 HRS)",
        details: [
          "Welcome to God’s Own Country! Following your arrival at the Cochin International Airport, you will be warmly greeted by our tour guides and representatives.",
          "Post this, you will be driven towards Munnar or the ‘Nature Lover’s Paradise’.",
          "Arriving in Munnar, check-in into a hotel or a resort and unwind yourself for a leisure day.",
          "Overnight stay in Munnar",
        ],
      },
      {
        day: "02",
        title: "MUNNAR SIGHTSEEING",
        details: [
          "Brace the playful morning light and wake up to a beautiful morning at the hotel/resort; get freshened up and enjoy a healthy breakfast.",
          "Post this, you will be guided for a full day sightseeing tour - Mattuppetty, Echo Point, Kundala Lake, Photo Point, Elephant Arrival Spot Cinema Shooting, and several other places.",
          "During the day, you will also visit Eravikulam National Park where you can enjoy spotting the exotic Nilgiri Tahr and several other wildlife species.",
          "Post this, a visit to Tata Tea Museum, International Blossom (Hydel) Park, will be visited during the day",
          "Overnight stay in Munnar",
        ],
      },
      {
        day: "03",
        title: "MUNNAR TO THEKKDAY (90KM / 03 HRS)",
        details: [
          "Today morning; following your breakfast at the Munnar hotel/resort, pack your bags and check-out from the hotel/resort.",
          "Hereafter, you will be driven towards the gorgeous Thekkady town.",
          "Following your arrival in the town, settle down in a hotel/resort and relax for a while.",
          "Post this, Embrace the enchanting beauty of God’s Own Country, and take an evening boat ride to national park.",
          "Coming back from the boat ride, you can go for local shopping and enjoy the local flavours of Thekkady",
          "Overnight stay in Thekkady",
        ],
      },
      {
        day: "04",
        title: "THEKKADY TO ALLEPPEY (150 KM / 04 HRS)",
        details: [
          "After breakfast is served at the Thekkady hotel/resort, you will be checked-out and driven towards Alleppey, the ‘Backwater Capital’ of Kerala.",
          "Also known as the ‘Venice of the East’.",
          "Enjoy Alleppey Day House Boat for an hour and in the Evening, Visit Alleppey Beach",
          "Overnight stay in Alleppey",
        ],
      },
      {
        day: "05",
        title: "ALLEPPEY TO KOLLAM",
        details: [
          "After breakfast, check-out from boat house and visit St. Andrew's Basilica, Arthunkal, later proceed to Jatayu Earth Centre.",
          "Morning after breakfast drive to Chadayamangalam to explore the Jatayu earth Centre.",
          "The giant concrete statue of Jatayu is built on a mighty rock named Jatayupara (para means rock in Malayalam).",
          "The colossal statue is 200 feet long, 150 feet wide and 70 feet making is the largest functional bird sculpture in the world with an enter into the Guinness Book of World Records.",
          "The Jatayu Rock Hill that represents the Safety of Women and their Honour",
          "In the evening proceed to Lighthouse and spend some time in the beach.",
          "Later proceed to check-in at hotel and Overnight stay.",
        ],
      },
      {
        day: "06",
        title: "DEPARTURE",
        details: [
          [
            "Today after your breakfast, check-out from your hotel and proceed to Trivendrum Airport, with the sweet memories of your tour with",
            " ",
            <strong> M D TOURS AND TRAVELS.</strong>,
          ],
        ],
      },
    ],
    inclusions: [
      "02 Night Accommodation in Munnar",
      "01 Night Accommodation in Thekkady",
      "01 Night Accommodation in Alleppey – Hotel",
      "01 Night Accommodation in Kollam",
      "Daily Breakfast",
      "Private Vehicle for 06 Days",
      "Return flight fare",
      "Transfers and Sightseeing as per the Itinerary",
      "GST",
    ],
    exclusions: [
      "Lunch & Dinner not included",
      "Entrance Fees for Sightseeing /Activities / Boating",
      "Any expenses not mentioned under the inclusions",
    ],
  },

  //Rajasthan 5N/6D Tour
  {
    id: 2,
    title: "Rajasthan Explorer",
    subtitle: "Jaipur - Jodhpur - Udaipur",
    image: rajasthan1,
    images: [rajasthan1, rajasthan2, rajasthan3, rajasthan4],
    overview:
      "Rajasthan tour covering Jodhpur, Jaipur, and Udaipur offers a rich journey through royal heritage, majestic forts, and grand palaces including Mehrangarh Fort, Amber Fort, and City Palace, while showcasing vibrant bazaars, colorful culture, and traditional Rajasthani lifestyle; the Blue City of Jodhpur reflects timeless history, Jaipur charms with its Pink City architecture and royal legacy, and Udaipur enchants travelers with romantic lakes, serene boat rides, and breathtaking sunset views, all complemented by authentic Rajasthani cuisine and warm royal hospitality.",
    duration: "5 Nights / 6 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL JAIPUR AND JAIPUR SIGHTSEEING",
        details: [
          "Arrive in Jaipur and proceed to Jaipur Local Sightseeing – Visit Birla Temple, Birla Auditorium and Albert Hall",
          "Lunch at outside restaurant (Own expenses)",
          "Later proceed to Visit Local Market and Nahargarh Fort (sunset view over city)",
          "Return back to hotel and Overnight Stay in Jaipur",
        ],
      },
      {
        day: "02",
        title: "JAIPUR LOCAL SIGHTSEEING",
        details: [
          "Breakfast at Hotel",
          "Proceed to excursion to Amber Fort and enjoy the elephant ride (Direct Pay)- See the largest cannon on wheels in the world, and old cannon foundry at Jaigarh.",
          "Visit to the KanakVrindavan Temple in the valley of flowers.",
          "Drive through the Johari Bazaar or the old jeweler's market to HawaMahal (Palace of Winds).",
          "Visit the various museums inside the City Palace and the ancient observatory and JantarMantar.",
          "Evening free for your independent activities and Return back to hotel and Overnight in Jaipur",
          "Meals – Breakfast and Dinner",
        ],
      },
      {
        day: "03",
        title: "JAIPUR TO JODHPUR VIA AJMER AND PUSHKER (09 HRS / 400 KMS)",
        details: [
          "After breakfast, check out of the hotel and proceed to Udaipur via Ajmer and Pushker",
          "Driver will take you to Visit the Dargah Sharif - a pilgrimage Centre for the shrine of the Sufi Saint KhwajaMoinuddinChishti , here are thousands of pilgrims come every day and made more famous by the movies and the Bollywood celebrities this place is worth a visit.",
          "After that you will drive for Holy City of PushkarUpon arrival to Pushkar - we will Firstly take you to visit the Brahma Temple the one and only temple in the world dedicated to Brahma, the creator of the world in Hindu mythology. Legend has it that his wife placed a curse on him that restricts his worship to this one city.",
          "After that driver will take you to the Pushkar Lake which is surrounded by 52 bathing ghats (a series of steps leading to the lake), where pilgrims throng in large numbers to take a sacred bath, A dip in the sacred lake is believed to cleanse sins and cure skin diseases.",
          "After Seeing the Beauty of Pushkar City, proceed to Jodhpur",
          "Upon arrival Jodhpur, check in to hotel and overnight stay in Jodhpur",
          "Meals – Breakfast & Dinner",
        ],
      },
      {
        day: "04",
        title: "JODHPUR TO UDAIPUR (250 KMS)",
        details: [
          "Breakfast from Hotel. Later checkout and proceed to Udaipur.",
          "Arrival at Udaipur, proceed to the hotel.",
          "Check in to the Hotel",
          "Dinner and Overnight stay at Hotel in Udaipur",
          "Meals – Breakfast and Dinner",
        ],
      },
      {
        day: "05",
        title: "UDAIPUR SIGHTSEEING",
        details: [
          "Breakfast from Hotel",
          "Proceed to Udaipur Sightseeing tour – Visit Museum of Folk Art, which has a rich collection of folk dresses, puppets, dolls, masks, ornaments, folk musical instruments and paintings on display.",
          "Afterwards, visit the City Palace, the biggest palace complex in India, where four generations of Maharajas added mansions and palaces. You must also visit the museum of the palace which includes the beautiful peacock mosaic and miniature wall paintings of Indian mythology.",
          "The visit Durbar Hall, Crystal Art Gallery, Jagdish Temple, MaharanaPratap Memorial and drive past the FatehSagar Lake",
          "Return back to hotel and overnight stay",
          "Meals – Breakfast and Dinner",
        ],
      },
      {
        day: "06",
        title: "UDAIPUR SHOPPING AND DROP TO UDAIPUR AIRPORT",
        details: [
          "After your breakfast check-out from Hotel and het dropped to Airport.",
          [
            "Drop off Jaipur Airport with the great memories of your tour organized by RL TOURS AND TRAVELS",

            " ",
            <strong> M D TOURS AND TRAVELS.</strong>,
          ],
          "Meals – Breakfast",
        ],
      },
    ],
    inclusions: [
      "02 Nights’ Accommodation in Jaipur",
      "01 Night Accommodation in Jodhpur",
      "02 Night Accommodation in Udaipur",
      "Meal Plan on Breakfast & Dinner Basis",
      "Sedan Card for 06 Days",
      "Tours and Transfers as per the Itinerary",
      "01 Ltr Water bottle Per Person Per Day",
      "Round Flight Fares Inclusive of Taxes",
      "Applicable all the taxes",
    ],
    exclusions: [
      "Lunch",
      "Personal expenses",
      "Entrance Tickets & Ticket for other activities",
      "Any other expense not mentioned in the inclusions",
    ],
  },

  //Chardham 11N/12D Tour
  {
    id: 3,
    title: "Char Dham Yatra",
    subtitle: "Yamunotri - Gangotri - Kedarnath - Badrinath",
    image: chardham1,
    images: [chardham1, chardham2, chardham3, chardham4],
    overview:
      "Char Dham Yatra is a sacred pilgrimage covering Yamunotri, Gangotri, Kedarnath, and Badrinath, symbolizing spiritual purification and deep devotion in the majestic Himalayas; the journey takes pilgrims through breathtaking mountain landscapes, holy rivers, snow-clad peaks, and ancient temples steeped in mythology, offering moments of prayer, reflection, and inner peace, while the challenging routes strengthen faith and resilience, making the yatra a spiritually enriching and life-transforming experience that connects devotees with age-old traditions, divine energy, and the serene beauty of Uttarakhand.",
    duration: "11 Nights / 12 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL AT DELHI – HARIDWAR (225 KMS 6-7 HRS)",
        details: [
          "Upon arrival at Delhi Airport/ Railway station you will get a warm welcome from tour Manager. Transfer to Haridwar hotel.",
          "On arrival at Haridwar Check in into the hotel.",
          'Haridwar: The holy city of Haridwar translates to "Gateway to God," and the breathtaking city, replete with temples, is a magnet for religious pilgrims from all over the globe.',
          "Religious festivals hold even further draw, and tourists can’t be helped but are compelled by the city’s aura of intense spirituality.",
          "Haridwar is one of the seven holiest places of the Hindus, located on the banks of River Ganges.",
          "The sheer numbers of people gathering around Har-ki-Pauri Ghat give Haridwar a chaotic but reverent feel.",
          "Evening visit Mansa Devi Temple & Ganga aarti at Har Ki Pauri.",
          "Overnight stay at Haridwar.",
          "Meals: Dinner",
        ],
      },
      {
        day: "02",
        title: "HARIDWAR – BARKOT (210 KMS / 7-8 HRS)",
        details: [
          "Morning breakfast check out from hotel and proceed to Barkot via Mussoorie, Enroute visit Mussoorie Lake & Kempty Fall in Mussoorie.",
          "Later drive straight to Barkot.",
          "On arrival check into the hotel in Barkot.",
          "Overnight stay at Barkot.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "03",
        title:
          "BARKOT - YAMUNOTRI – BARKOT (36 KMS DRIVE & 6 KMS TREK (ONE SIDE)",
        details: [
          "Early morning after breakfast drive to Jankichatti / Phoolchatti and start trek from here to Yamunotri (6kms) (Either by walk or by horse or by Doli at own cost).",
          'After taking bath in Jamunabai Kund\'s warm water and having "Darshan" of "Yamunaji" return to Jankichatti by trek.',
          "Later drive towards Barkot",
          "Overnight stay at Barkot.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "04",
        title: "BARKOT – UTTARKASHI (100 KMS / 4 HRS)",
        details: [
          "The morning after breakfast, drive to Uttarkashi.",
          "Check into the hotel's arrival in Uttarkashi: is home to a number of ashrams, temples.",
          "The name of the town reflects its similarity to and location (as north of) the city of Kashi (Varanasi).",
          "Similar to Varanasi, the town of Uttarkashi is also situated on the banks of River Ganga.",
          "Visit Kashi Vishwanath Temple in Uttarkashi.",
          "Overnight stay at Uttarkashi.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "05",
        title: "UTTARKASHI – GANGOTRI – UTTARKASHI (100 KMS)",
        details: [
          "Early morning drive to Gangotri, En route at Gangnani, take a holy dip in Garam Kund, further drive to Gangotri via beautiful Harsil Valley.",
          "Harsil is famous for its natural beauty and for the majestic views of the Deodar trees and mountains.",
          "On arrival at Shree Gangotri, take a holy dip in the sacred river Ganges which is also called Bhagirathi at its origin.",
          "Perform Pooja and Darshan, after that relax for some time in the lovely surroundings.",
          "Later drive back to Uttarkashi and",
          "Overnight stay at Uttarkashi.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "06",
        title: "UTTARKASHI - GUPTKASHI (220 KMS 8-9 HRS)",
        details: [
          "The morning after breakfast, drive to Guptkashi via Moolgarh & Lambgoan.",
          "Enroute you can see the beautiful river Mandakini at Tilwara.",
          "The Mandakini River comes from Kedarnath, drive alongside the river to reach Guptakashi, visit Ardh Narishwar Temple in Guptakashi.",
          "On arrival Check into the hotel in Guptakashi.",
          "Overnight stay at Guptakashi.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "07",
        title: "GUPTKASHI – KEDARNATH (30 KMS BY ROAD & 22 KMS TREK ONE WAY)",
        details: [
          "The morning after breakfast drive to Gaurikund, start your trek from Gaurikund to Kedarnath.",
          "(By Pony / Doli / Helicopter at your own cost)",
          "Overnight stay at hotel",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "08",
        title: "KEDARNATH – GUPTKASHI (30 KMS BY ROAD & 22 KMS TREK ONE WAY)",
        details: [
          "The morning Visit Kedarnath Temple and back to hotel have breakfast and after breakfast trek down to Gaurikund.",
          "Later, drive to Guptkashi and",
          "Overnight stay at Guptakashi.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "09",
        title: "GUPTKASHI – BADRINATH (160 KMS /7 HRS APPROX.) HEIGHT: 3300",
        details: [
          "The morning after breakfast, drive to Badrinath.",
          "On arrival check in to the hotel in Badrinath.",
          "Pilgrims after having a bath in the Taptkund have the Darshan of Badrivishal & Aarti in the evening.",
          "Brahamakapal is significant for Pinddan Shraddh of ancestors (Pitrus).",
          'There are other interesting sightseeing spots like Mana, Vyas Gufa, Maatamoorti, Charanpaduka, Bhimkund and the "Mukh" of the Saraswati River.',
          "Just within the three km of Badrinathjee.",
          "Overnight stay at Badrinath.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "10",
        title: "BADRINATH - JOSHIMATH – RUDRAPRAYAG (160 KMS / 7 HRS)",
        details: [
          "The morning after breakfast, the driver for Rudraprayag via Joshimath.",
          "Visit on the way Narsingh Temple in Joshimath later drive back to Rudraprayag via Joshimath.",
          "Check into the hotel's arrival in Rudraprayag.",
          "Overnight stay at Rudraprayag.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "11",
        title: "RUDRAPRAYAG –HARIDWAR (165 KMS /6 – 7 HRS)",
        details: [
          "The morning after breakfast, drive for Haridwar via Rishikesh 'place of sages' is a celebrated spiritual town on the bank of Ganga and is surrounded by Shivalik range of the Himalayas on three sides.",
          "It is said that when Raibhya Rishi did hard penances, God appeared by the name of “Hrishikesh” and this area hence firth came to be known as Rishikesh.",
          "Visit Rishikesh Temples & Sight Seeing – Laxman Jhulla, Ram Jhulla.",
          "Later proceed to Haridwar on arrival at Haridwar Check-in Hotel and overnight stay at Haridwar.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "12",
        title: "HARIDWAR – DELHI – DEPARTURE (225KMS / 6 -7 HRS)",
        details: [
          "Morning after breakfast, check out from hotel drop at Delhi airport.",
          "Tour Ends with Sweet Memories.",
          "Meals: Breakfast",
        ],
      },
    ],
    inclusions: [
      "11 Nights of accommodation",
      "Meal plan on MAP (Breakfast + Dinner)",
      "12 days of Vehicle",
      "Round flight Tickets",
      "Tours and Transfers as per the itinerary",
      "Applicable all the Taxes",
    ],
    exclusions: [
      "Lunch",
      "Helicopter Ticket Cost for Kedarnath, Yamunotri, Gangotri & Badrinath.",
      "Personal expenses",
      "Guide Charges",
      "Porter, pony, horse, cable car, boat, train tickets, air tickets charges.",
      "Any other expenses not mentioned in the inclusions",
    ],
  },

  //Chardham 11N/12D Tour by Helicopter
  {
    id: 4,
    title: "Char Dham Yatra by Helicopter",
    subtitle: "Yamunotri - Gangotri - Kedarnath - Badrinath",
    image: chardham2,
    images: [chardham1, chardham2, chardham3, chardham4],
    overview:
      "Char Dham Yatra is a sacred pilgrimage covering Yamunotri, Gangotri, Kedarnath, and Badrinath, symbolizing spiritual purification and deep devotion in the majestic Himalayas; the journey takes pilgrims through breathtaking mountain landscapes, holy rivers, snow-clad peaks, and ancient temples steeped in mythology, offering moments of prayer, reflection, and inner peace, while the challenging routes strengthen faith and resilience, making the yatra a spiritually enriching and life-transforming experience that connects devotees with age-old traditions, divine energy, and the serene beauty of Uttarakhand.",
    duration: "7 Nights / 6 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVE AT DEHRADUN",
        details: [
          "Meet our representative and transfer to hotel",
          "Overnight stay in hotel",
        ],
      },
      {
        day: "02",
        title: "DEHRADUN TO YAMUNOTRI",
        details: [
          "07:00AM DEPARTURE S’DHARA HELIPAD, DEHRADUN",
          "07:45AM ARRIVAL KHARSALI HELIPAD, YAMUNOTRI",
          "Passengers are requested to reach state government helipad on Sahastradhara Road, Dehradun which is the starting and ending point of this yatra. Vehicles are arranged for pick up.",
          "Our pilots and ground staff will brief the guest about the entire trip and do’s and don’ts. Breakfast will be arranged at Kharsali and passengers are supposed to leave their hotel early at Dehradun/Haridwar.",
          "Upon arrival at Kharsali (The helipad for Yamunotri) passengers are welcomed by Aviation, ground staff, who will unload their baggage and carry it to your hotel.",
          "Temple is a 6 KMS trek which will be cover by palki. Total journey will take approx.5 hr 30 min.",
          "Generally passengers will return to hotel by lunch time.",
          "After rest, we do visit to shani temple which is near to your hotel.",
        ],
      },
      {
        day: "03",
        title: "YAMUNOTRI TO GANGOTRI",
        details: [
          "07:45 AM DEPARTURE YAMUNOTRI HELIPAD",
          "08:30 AM ARRIVAL HARSIL HELIPAD, GANGOTRI",
          "Harsil is one of the most beautiful and picturesque valleys in Uttrakhand anlso known as mini Switzerland.",
          "Gangotri temple is approx 22 Kms from Harsil helipad and drive by car is approx. 50 mins.",
          "Stay at Harsil is arranged at Himalayan Nature Resort which is around 2 KMS from helipad.",
          "Our ground staff will assist passengers through out there stay at Harsil.",
          "We provide all the basic and leisure facilities for the tourists such as a premium accommodation with ensuite washrooms, delicious vegetarian food, short walks, local sightseeing and an evening bonfire in Gangotri Valley.",
        ],
      },
      {
        day: "04",
        title: "GANGOTRI TO KEDARNATH",
        details: [
          "09:00 AM DEPARTURE HARSIL HELIPAD, GANGOTRI",
          "10:00 AM ARRIVAL KEDARNATH HELIPAD",
          "Kedarnath is flanked by breathtaking snow-capped peaks, most remote site among all four Char Dham sites.",
          "We will arrive to phata helipad from Gangotri, here after changing the chopper we will fly for KEDARNATH Helipad.",
          "Temple is approx. 500 meters away from helipad and will take approx. 15 min to reach.",
          "Kedarnath doesn’t have night halt facility, once the Darshan is completed, we will return to Guptkashi and stay is arranged at Guptkashi / Sitapur.",
          "Passengers can visit ancient Triyuginarayan or Kalimath Mandir in the evening",
        ],
      },
      {
        day: "05",
        title: "KEDARNATH TO BADRINATH",
        details: [
          "10:00 AM DEPARTURE SERSI HELIPAD, GUPTKASHI",
          "11:00 AM ARRIVAL BADRINATH HELIPAD",
          "Badrinath has an average elevation of 3,100 metres.",
          "According to legend shankara discovered a black stone image of lord badirnarayan made of saligram stone in the alaknanda river.",
          "After arrival, passengers can check in to hotel sarovar portico which is close to temple.",
          "In evening, we do visit of mana village which is near to religious site of badrinath.",
          "The special maha abhishek pooja is the highlight of this entire yatra.",
          "It starts at 0400am sharp in the morning and last for 2 hours.",
          "We have arranged an opportunity for all our guest to sit inside the temple and cherishesthe darshan of the shringar of the deity from close quarters.",
        ],
      },
      {
        day: "06",
        title: "DEPARTURE BADRINATH TO DEHRADUN",
        details: [
          "11:30 AM DEPARTURE BADRINATH HELIPAD",
          "12:30 PM ARRIVAL S’DHARA HELIPAD, DEHRADUN",
        ],
      },
    ],
    inclusions: [
      "Helicopter flying from Dehradun",
      "Pick and drop facility from Dehradun Airport.",
      "05 Night Accommodation with Meals",
      "Priority / VIP Darshan arrangements at Yamunotri, Gangotri, Kedarnath, Badrinath",
      "All road transfers by Innova Crysta / similar.",
      "All Government taxes (Landing, Parking, Handling Charges and Royalty charges)",
    ],
    exclusions: [
      "Palki at Yamunotri",
      "Maha Abhishek puja at badrinath",
      "Tea, snacks and mineral water",
      "Travel Insurances",
      "Any upgradation cost",
      "Any specific service apart from mentioned above",
      "Any additional activities apart from mentioned above",
      "Other expenses of personal nature",
    ],
  },

  //Do Dham Yatra 6N/7D Tour
  {
    id: 6,
    title: "Sacred Do Dham Yatra",
    subtitle: "Kedarnath – Badrinath",
    image: chardham1,
    images: [chardham1, chardham2],
    overview: [
      [
        "The Do Dham Yatra covering Kedarnath and Badrinath is one of the most sacred pilgrimages in India, nestled in the majestic Himalayas of Uttarakhand. Kedarnath, dedicated to Lord Shiva, is surrounded by snow-clad peaks and spiritual serenity. Badrinath, devoted to Lord Vishnu, lies along the banks of the Alaknanda River and is revered for its divine significance. This holy journey offers devotees a deep spiritual experience combined with breathtaking natural beauty. The yatra is believed to cleanse the soul and bring peace, devotion, and blessings.🕉️",
      ],
    ],
    duration: "4 Nights / 5 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL IN HARIDWAR / RISHIKESH",
        details: [
          "Arrived in Haridwar / Rishikesh",
          " Meet and Greet at Railway Station / Airport",
          " Transfer to Hotel",
          " Check in Hotel",
          " Evening visit to Ganga Aarti at Har Ki Pauri / Triveni Ghat",
          " Overnight stay in Haridwar / Rishikesh",
        ],
      },
      {
        day: "02",
        title: "HARIDWAR / RISHIKESH TO GUPTKASHI",
        details: [
          " Breakfast at the Hotel",
          " Check out from Hotel",
          " Drive to Guptkashi",
          "*Approx 7-8 hours drive depending on road and weather conditions*",
          " Enroute visit Devprayag",
          " Arrival in Guptkashi / Check in Hotel",
          " Visit Kashi Vishwanath Temple, Guptkashi",
          " Overnight stay in Guptkashi",
        ],
      },
      {
        day: "03",
        title: "GUPTKASHI – KEDARNATH – GUPTKASHI",
        details: [
          " Early morning breakfast",
          " Drive to Gaurikund",
          " Trek from Gaurikund to Kedarnath Temple",
          "*Approx 16 km trek one way*",
          " Visit Kedarnath Temple",
          " Perform Darshan and Pooja",
          " Trek back to Gaurikund",
          " Drive back to Guptkashi",
          " Overnight stay in Guptkashi",
        ],
      },
      {
        day: "04",
        title: "GUPTKASHI TO BADRINATH",
        details: [
          " Breakfast at the Hotel",
          " Check out from Hotel",
          " Drive to Badrinath",
          "*Approx 8-9 hours drive depending on road conditions*",
          " Enroute visit Joshimath",
          " Arrival in Badrinath / Check in Hotel",
          " Visit Badrinath Temple",
          " Evening Aarti at Badrinath Temple",
          " Overnight stay in Badrinath",
        ],
      },
      {
        day: "05",
        title: "BADRINATH TO HARIDWAR / RISHIKESH – DEPARTURE",
        details: [
          " Early morning Darshan at Badrinath Temple",
          " Breakfast at the Hotel",
          " Check out from Hotel",
          " Visit Mana Village (Last Indian Village)",
          " Drive back to Haridwar / Rishikesh",
          "*Approx 9-10 hours drive*",
          " Drop at Railway Station / Airport",
          " Departure with Divine Memories",
        ],
      },
    ],
    inclusions: [
      "Hotel Accommodation",
      "Daily Hotel Breakfast",
      "All transfers and sightseeing as per itinerary",
      "Driver allowance, tolls and parking",
      "Assistance during Yatra",
    ],
    exclusions: [
      "Airfare / Train fare",
      "Helicopter charges for Kedarnath",
      "Pony / Palki charges",
      "All personal expenses",
      "Meals not mentioned in the itinerary",
      "Travel Insurance",
      "5% GST and bank transfer charges",
    ],
  },

  //Ayodhya & Varanasi Tour 5N/6D Tour
  {
    id: 5,
    title: "Divine Ayodhya & Varanasi",
    subtitle: "Ayodhya – Varanasi",
    image: varanasi1,
    images: [varanasi1, varanasi2, varanasi3],
    overview: [
      [
        "Ayodhya and Varanasi are among the holiest cities in India, deeply rooted in spirituality, history, and devotion. Ayodhya, the birthplace of Lord Rama, reflects ancient traditions, sacred ghats, and timeless temples. Varanasi, the eternal city on the banks of the River Ganga, is known for its spiritual aura, ancient rituals, and mesmerizing Ganga Aarti. Together, these sacred destinations offer a profound journey through Hindu culture, faith, and centuries-old traditions. The experience promises inner peace, devotion, and unforgettable spiritual moments.🕉️",
      ],
    ],
    duration: "3 Nights / 4 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL IN AYODHYA",
        details: [
          "Arrived in Ayodhya",
          " Meet and Greet at Airport / Railway Station",
          " Transfer to Hotel",
          " Check in Hotel",
          " Visit Ram Janmabhoomi Temple",
          " Visit Hanuman Garhi",
          " Evening visit to Saryu River Ghats",
          " Overnight stay in Ayodhya",
        ],
      },
      {
        day: "02",
        title: "AYODHYA SIGHTSEEING + TRANSFER TO VARANASI",
        details: [
          " Breakfast at the Hotel",
          " Visit Kanak Bhawan",
          " Visit Dashrath Mahal",
          " Visit Nageshwarnath Temple",
          " Check out from Hotel",
          " Transfer to Varanasi",
          "*Approx 5-6 hours drive depending on traffic conditions*",
          " Arrival in Varanasi / Check in Hotel",
          " Overnight stay in Varanasi",
        ],
      },
      {
        day: "03",
        title: "VARANASI CITY TOUR & GANGA AARTI",
        details: [
          " Early morning boat ride on River Ganga",
          " Visit Dashashwamedh Ghat",
          " Visit Assi Ghat",
          " Breakfast at the Hotel",
          " Visit Kashi Vishwanath Temple",
          " Visit Annapurna Temple",
          " Visit Sankat Mochan Hanuman Temple",
          " Visit Banaras Hindu University",
          " Evening Ganga Aarti at Dashashwamedh Ghat",
          " Overnight stay in Varanasi",
        ],
      },
      {
        day: "04",
        title: "DEPART VARANASI",
        details: [
          " Breakfast at the Hotel",
          " Check out from Hotel",
          " Transfer to Varanasi Airport / Railway Station",
          " Departure with Divine Memories",
        ],
      },
    ],
    inclusions: [
      "Hotel Accommodation",
      "Daily Hotel Breakfast",
      "Airport / Railway Station Transfers",
      "Sightseeing as per itinerary",
      "Boat ride on River Ganga",
      "All applicable sightseeing transfers",
    ],
    exclusions: [
      "Airfare / Train fare",
      "All personal expenses",
      "Meals not mentioned in the itinerary",
      "Camera / Video charges at monuments",
      "Travel Insurance",
      "5% GST and bank transfer charges",
    ],
  },

  // Kashmir 5N/6D Tour
  {
    id: 5,
    title: "Kashmir",
    subtitle: "Srinagar - Gulmarg - Pahalgam - Sonmarg",
    image: kashmir3,
    images: [kashmir1, kashmir2, kashmir3, kashmir4],
    overview:
      "Kashmir tour offers an enchanting journey through snow-capped mountains, lush valleys, and serene lakes, highlighted by the beauty of Srinagar, Gulmarg, Pahalgam, and Sonmarg; enjoy a shikara ride on Dal Lake, stroll through Mughal gardens, witness breathtaking landscapes and meadows, experience local culture and handicrafts, and savor authentic Kashmiri cuisine, making the trip a perfect blend of nature, tranquility, and unforgettable experiences.",
    duration: "5 Nights / 6 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL + SHIKARA RIDE",
        details: [
          "Meet our representative at Srinagar airport, transfer to House Boat.",
          "In the evening, Shikara ride in the world famous Dal lake.",
          "Overnight stay at Srinagar.",
          "Meals: Dinner",
        ],
      },
      {
        day: "02",
        title: "SRINAGAR – GULMARG (54 KMS)",
        details: [
          "After breakfast, transfer to Gulmarg via Tangmarg",
          "En-route Apple Orchards, Cherry Orchards (In Summer Time). In Gulmarg visit Khilanmarg",
          'Take a ride in the world\'s highest cable car "Gondola" or enjoy your day by playing golf in the world’s highest golf course.',
          "Overnight stay at Gulmarg.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "03",
        title: "GULMARG – PAHALGAM (148 KMS ON WAY)",
        details: [
          "After breakfast, transfer to Pahalgam",
          "Enroute visit Saffron Fields.",
          "In Pahalgam you can visit: - Aru , Betaab valley (at your own cost).",
          "Overnight stay at a hotel in Pahalgam.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "04",
        title: "PAHALGAM TO SRINAGAR + SS OF MUGHAL GARDEN (119 KMS ON WAY)",
        details: [
          "After breakfast, transfer to srinagar, check in at the hotel.",
          "Afternoon, leave for local sightseeing of Srinagar City. Visit: - Mughal gardens: - CheshmaShahi (Mughal Spring), Nishat (The Garden of Bliss), Shalimar (The Abode of Love).",
          "Overnight stay at hotel in Srinagar.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "05",
        title: "SRINAGAR – SONMARG – SRINAGAR (89 KMS ON WAY)",
        details: [
          "After breakfast, transfer to Sonmarg for a daytrip.",
          "Enroute see Hazratbal Shrine, Gagangir Tourist Village.",
          "The drive from Srinagar to Sonmarg is very beautiful as you will pass through some towns and villages, at many places you can enjoy the view of paddy fields with rivers flowing on one side.",
          "In Sonmarg you can visit Thajwas Glacier which is around 4 Kms from Sonmarg, a local taxi has to be hired for it (at your own cost ).",
          "The name Sonmarg is derived from two Kashmiri words “Son” & “Marg” which mean “Gold” & “Meadow”, when put together it means “Meadow of Gold ''.",
          "Return to Srinagar in the evening after enjoying your day.",
          "Overnight stay at Srinagar.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "06",
        title: "DEPARTURE",
        details: [
          "After breakfast, transfer to Srinagar airport, with the memories of your trip organized by RL TOURS & TRAVELS",
        ],
      },
    ],
    inclusions: [
      "01 Night in Houseboat in Dal Lake",
      "01 night in in Pahalgam",
      "01 night in In Gulmarg",
      "02 nights in Srinagar",
      "Meal Plan on (Breakfast + Dinner) basis- Lunch Not Included",
      "All Sightseeing & transfers by NON AC Vehicle",
      "01 hour shikara ride",
      "Return Flight Fares Inclusive of Taxes",
      "Toll, tax, driver allowance for all trips",
      "GST 5%",
    ],
    exclusions: [
      "Lunch",
      "Entrance fees / Tickets to monuments / Park / Cable cars, etc.",
      "Any other expenses not mentioned under the inclusions.",
      "Garden entrance fees and Guide charges, where ever applicable.",
      "Trip to Aru, Chandanwari&Betaab Valley in Pahalgam",
      "Gondola ride in Gulmarg – Have to book online before 10 days minimum.",
      "Thajiwas Glacier & Snow Point in Sonmarg",
      "Snow Jeep from Tangmarg to Gulmarg & back, (Applicable from Nov – February Month)",
      "Item of personal nature viz, tips, laundry, room service, telephone, alcoholic or non-alcoholic beverages, room heaters, boat rides, pony / horse rides, safaris, rafting, skiing, skating, cable car / ropeway rides, helicopter rides, additional sightseeing tours excursions not included in the itinerary, still or video camera fees etc.",
      "Any kind of insurance, Air, Train or Bus fare from / to your originating city of stay, unless specified",
      "Lunch and personal expenses like entry ticket any, telephone laundry, or anything which is not mentioned above.",
      "Any Tax & Government Service tax (5%)",
      "Any Kind of Personal Expenses or Optional Tours / Extra Meals Ordered",
      "Anything not specifically mentioned under the head “Prices included”. The services of vehicle are not included on leisure days & after finishing the sightseeing tour as per the itinerary",
      "Additional costs due to flight cancellation, road blocks etc.",
      "Medical & Travel insurance",
    ],
  },

  // Kashmir with Amritsar 7N/8D Tour
  {
    id: 5,
    title: "Kashmir with Amrirtsar",
    subtitle: " Srinagar - Gulmarg - Pahalgam - Amritsar",
    image: kashmir2,
    images: [kashmir1, kashmir2, kashmir3, kashmir4, amritsar1],
    overview:
      "Kashmir with Amritsar tour offers a perfect blend of breathtaking natural beauty and profound cultural spirituality, starting with the serene valleys, snow-capped mountains, lush gardens, and tranquil Dal Lake of Kashmir, complemented by scenic drives and charming hill towns, while Amritsar adds a soulful dimension with the sacred Golden Temple, vibrant bazaars, rich Punjabi culture, and the patriotic Wagah Border ceremony, creating a journey that beautifully combines nature, heritage, devotion, and unforgettable experiences.",
    duration: "7 Nights / 8 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL + SHIKARA RIDE",
        details: [
          "Meet our representative at Srinagar airport, transfer to House Boat.",
          "In the evening, Shikara ride in the world famous Dal lake.",
          "Overnight stay at Srinagar.",
          "Meals: Dinner",
        ],
      },
      {
        day: "02",
        title: "SRINAGAR – GULMARG (54 KMS)",
        details: [
          "After breakfast, transfer to Gulmarg via Tangmarg",
          "En-route Apple Orchards, Cherry Orchards (In Summer Time). In Gulmarg visit Khilanmarg and",
          'Take a ride in the world\'s highest cable car "Gondola" or enjoy your day by playing golf in the world’s highest golf course.',
          "Overnight stay at Gulmarg.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "03",
        title: "GULMARG – PAHALGAM (148 KMS ON WAY)",
        details: [
          "After breakfast, transfer to Pahalgam",
          "Enroute visit Saffron Fields.",
          "In Pahalgam you can visit: - Aru , Betaab valley (at your own cost).",
          "Overnight stay at a hotel in Pahalgam.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "04",
        title: "PAHALGAM TO SRINAGAR + SS OF MUGHAL GARDEN (119 KMS ON WAY)",
        details: [
          "After breakfast, transfer to srinagar, check in at the hotel.",
          "Afternoon, leave for local sightseeing of Srinagar City. Visit: - Mughal gardens: - CheshmaShahi (Mughal Spring), Nishat (The Garden of Bliss), Shalimar (The Abode of Love).",
          "Overnight stay at hotel in Srinagar.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "05",
        title: "SRINAGAR – SONMARG – SRINAGAR (89 KMS ON WAY)",
        details: [
          "After breakfast, transfer to Sonmarg for a daytrip.",
          "Enroute see Hazratbal Shrine, Gagangir Tourist Village.",
          "The drive from Srinagar to Sonmarg is very beautiful as you will pass through some towns and villages, at many places you can enjoy the view of paddy fields with rivers flowing on one side.",
          "In Sonmarg you can visit Thajwas Glacier which is around 4 Kms from Sonmarg, a local taxi has to be hired for it (at your own cost ).",
          "The name Sonmarg is derived from two Kashmiri words “Son” & “Marg” which mean “Gold” & “Meadow”, when put together it means “Meadow of Gold ''.",
          "Return to Srinagar in the evening after enjoying your day.",
          "Overnight stay at Srinagar.",
          "Meals: Breakfast & Dinner",
        ],
      },
      {
        day: "06",
        title: "SRINAGAR TO AMRITSAR",
        details: [
          "After breakfast at the hotel check out, fly back to Amritsar.",
          "Early Check out from hotel reach Amritsar visit for sightseeing’s places like Golden temple.",
          "Overnight stay in hotel.",
        ],
      },
      {
        day: "07",
        title: "AMRITSAR",
        details: [
          "After breakfast, visit Jalian wala bagh massacre, Rose and Rock Garden and after that visit Wagah boarder for evening beating retreat ceremony.",
          "Later evening free day by spending time shopping & at leisure.",
          "Overnight stay in hotel.",
        ],
      },
      {
        day: "08",
        title: "DEPARTURE",
        details: [
          [
            "After breakfast, transfer to airport, with the sweet memories of your trip organized by",

            " ",
            <strong> M D TOURS AND TRAVELS.</strong>,
          ],
        ],
      },
    ],
    inclusions: [
      "01 Night in Houseboat in Dal Lake",
      "01 night in in Pahalgam",
      "01 night in In Gulmarg",
      "02 nights in Srinagar",
      "02 night’s in Amritsar",
      "Meal Plan on (Breakfast + Dinner) basis- Lunch Not Included",
      "All Sightseeing & transfers by NON AC Vehicle",
      "01 hour shikara ride",
      "Return Flight Fares Inclusive of Taxes",
      "Toll, tax, driver allowance for all trips",
      "GST 5%",
    ],
    exclusions: [
      "Lunch",
      "Entrance fees / Tickets to monuments / Park / Cable cars, etc.",
      "Any other expenses not mentioned under the inclusions.",
      "Garden entrance fees and Guide charges, where ever applicable.",
    ],
  },

  // Shimla Manali 6N/7D Tour
  {
    id: 5,
    title: "Shimla & Manali",
    subtitle: "Chandigarh - Shimla - Manali",
    image: shimla1,
    images: [shimla1, shimla2, shimla3, shimla4, shimla5],
    overview:
      "Shimla and Manali tour offers a refreshing Himalayan escape with colonial charm and scenic mountain beauty, featuring the pleasant hill town of Shimla with its heritage architecture, Mall Road, and panoramic views, along with Manali’s snow-capped peaks, lush valleys, Solang Valley adventures, and serene riverside landscapes; the journey is ideal for nature lovers, honeymooners, and adventure seekers, blending relaxation, sightseeing, and unforgettable mountain experiences.",
    duration: "6 Nights / 7 Days",
    itinerary: [
      {
        day: "01",
        title: "CHANDIGARH TO SHIMLA (130 KMS / 04 HRS)",
        details: [
          "On arrival at Chandigarh Airport and Meet Our Representative Then drive to Shimla",
          "On arrival Check in Shimla Hotel.",
          "Overnight Stay at Hotel.",
          "Meals – Dinner",
        ],
      },
      {
        day: "02",
        title: "SHIMLA (FULL DAY TRIP TO KUFRI & LOCAL)",
        details: [
          "After Breakfast Excursion to Kufri. Kufri is famous for its Himalayan National Park, Pony and Yak Ride and one can see the endless Himalayan Panorama from Kufri, after lunch sightseeing of various places in and around.",
          "Shimla mosques built in (1830). Vice regal Lodge built in (1885), Christ Church built in (1844)",
          "The Gaiety Theatre- the first beauty contest of world was supposed to start (1887), The Grind lays Bank (1912)- the world wide bank started. by Robert Melville Grind lay",
          "The Scandal Point and the famous Shopping Plaza of the North the Mall.",
          "stay & Dinner at Hotel.",
          "Meals – Breakfast & Dinner",
        ],
      },
      {
        day: "03",
        title: "SHIMLA – MANALI (270 KMS / 08 HRS)",
        details: [
          "After Breakfast, Proceed to Manali via Pandoh Dam approx., Hanogi Mata Temple.",
          "Evening Check in hotel.",
          "Dinner & Overnight stay at hotel",
          "Meals – Breakfast & Dinner",
        ],
      },
      {
        day: "04",
        title:
          "SOLANG VALLEY (ROHTANG PASS ON DIRECT PAYMENT BASSIC SUBJECT TO PERMIT (20 K.M ROUND TOUR)",
        details: [
          "Rohtang Pass. Situated at an altitude of 3979 mtrs above sea level and 51 kms outside Manali is the mighty Rohtang Pass – the gateway to Lahaul-Spiti valley.",
          "It affords a wide panoramic view of the mountains. Here one sees the majesty of the mountains at its height and splendor.",
          "At the top of the pass the air seems to glitter against the snow as you look down over herringboned ridges into the Lahaul valley",
          "Overnight stay at hotel.",
          "Meals – Breakfast & Dinner",
        ],
      },
      {
        day: "05",
        title: "MANALI LOCAL SIGHTSEEING",
        details: [
          "After breakfast proceed to Manali Local sightseeing – Visit - Hidimba Temple, club house, Vashisht hot spring, Tibetan Monastery, Van vihar, Mall road by walk.",
          "Overnight stay at hotel.",
          "Meals – Breakfast & Dinner",
        ],
      },
      {
        day: "06",
        title: "MANALI – KULLU – CHANDIGARH (320 KMS / 10 HRS)",
        details: [
          "After Breakfast check out hotel. Depart for Chandigarh.",
          "On the way visit Kullu Vaishno Devi Temple, Kullu shawl weaving In.",
          "Chandigarh is the1st planned modern city of India designed by the French architect Le Corbusier.",
          "The city was named after the mother goddess of power, Chandi, whose temple Chandimandu is a feature of the new city",
          "On arrival check in hotel and Overnight stay at hotel",
          "Meals – Breakfast & Dinner",
        ],
      },
      {
        day: "07",
        title: "DEPARTURE",
        details: [
          "After Breakfast check out hotel. Visit Rose Garden, Rock Garden, Lake.",
          "Drop off Airport",
          "Tour Ends.",
          "You depart from Chandigarh with the enthralling memories of your trip with M D TOURS AND TRAVELS.",
          "Meals – Breakfast",
        ],
      },
    ],
    inclusions: [
      "02 Night Accommodation in Shimla",
      "03 Night Accommodation in Manali",
      "01 Night Accommodation in Chandigarh",
      "Daily Breakfast & Dinner in all the places",
      "Vehicle for 07 Days",
      "Entry tickets for sightseeing",
      "AC Not applicable in Hilly areas",
      "All sightseeing covered as per the itinerary.",
      "Round Trip Flight Fares inclusive of Taxes",
    ],
    exclusions: [
      "Lunch not included",
      "All optional items",
      "Expenses of personal nature like drinks, personal insurance, tips and telephone calls.",
      "Any additional expenses due to unforeseen problems like natural disaster, war or strikes, cancellation or misconnection of flight or last minute change of timings etc.",
      'Any other service, which has not been specified as "included".',
    ],
  },

  // Meghalaya
  {
    id: 8,
    title: "Mystical Meghalaya",
    subtitle: "Shillong – Cherrapunji – Dawki – Mawlynnong",
    image: megh1,
    images: [megh1, megh2, megh3, megh4],
    overview: [
      [
        "Meghalaya, known as the ‘Abode of Clouds’, is one of Northeast India’s most scenic destinations, blessed with lush green hills, misty valleys, cascading waterfalls, and living root bridges. From the charming hill town of Shillong to the rain-soaked landscapes of Cherrapunji and the crystal-clear waters of Dawki, Meghalaya offers a perfect blend of nature, culture, and serenity. The state is also rich in tribal heritage, unique traditions, and breathtaking viewpoints, making it an ideal escape for nature lovers and explorers.🌿",
      ],
    ],
    duration: "5 Nights / 6 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL IN GUWAHATI – TRANSFER TO SHILLONG",
        details: [
          "Arrived at Guwahati Airport / Railway Station",
          " Meet and Greet on arrival",
          " Drive to Shillong",
          "*Approx 3-4 hours drive*",
          " Enroute visit Umiam Lake",
          " Arrival in Shillong / Check in Hotel",
          " Evening free for leisure",
          " Overnight stay in Shillong",
        ],
      },
      {
        day: "02",
        title: "SHILLONG CITY TOUR",
        details: [
          " Breakfast at the Hotel",
          " Visit Shillong Peak",
          " Visit Elephant Falls",
          " Visit Don Bosco Museum",
          " Visit Ward’s Lake",
          " Visit Lady Hydari Park",
          " Evening free at Police Bazaar",
          " Overnight stay in Shillong",
        ],
      },
      {
        day: "03",
        title: "SHILLONG – CHERRAPUNJI",
        details: [
          " Breakfast at the Hotel",
          " Drive to Cherrapunji",
          "*Approx 2-3 hours drive*",
          " Visit Nohkalikai Falls",
          " Visit Seven Sisters Falls",
          " Visit Mawsmai Cave",
          " Visit Eco Park",
          " Check in Hotel",
          " Overnight stay in Cherrapunji",
        ],
      },
      {
        day: "04",
        title: "CHERRAPUNJI – DAWKI – MAWLYNNONG – SHILLONG",
        details: [
          " Breakfast at the Hotel",
          " Drive to Dawki",
          " Visit Umngot River (Crystal Clear River)",
          " Drive to Mawlynnong (Asia’s Cleanest Village)",
          " Visit Living Root Bridge",
          " Explore village life and viewpoints",
          " Return to Shillong",
          " Overnight stay in Shillong",
        ],
      },
      {
        day: "05",
        title: "SHILLONG – GUWAHATI",
        details: [
          " Breakfast at the Hotel",
          " Drive back to Guwahati",
          "*Approx 3-4 hours drive*",
          " Visit Kamakhya Temple",
          " Evening Brahmaputra River Cruise (optional)",
          " Check in Hotel",
          " Overnight stay in Guwahati",
        ],
      },
      {
        day: "06",
        title: "DEPART GUWAHATI",
        details: [
          " Breakfast at the Hotel",
          " Check out from Hotel",
          " Transfer to Guwahati Airport / Railway Station",
          " Departure with Beautiful Memories",
        ],
      },
    ],
    inclusions: [
      "Hotel Accommodation",
      "Daily Hotel Breakfast",
      "All transfers and sightseeing as per itinerary",
      "Driver allowance, tolls and parking",
      "Local assistance during the tour",
    ],
    exclusions: [
      "Airfare / Train fare",
      "All personal expenses",
      "Meals not mentioned in the itinerary",
      "Entry fees at monuments and attractions",
      "Camera / Video charges",
      "Travel Insurance",
      "5% GST and bank transfer charges",
    ],
  },

  //Arunachal
  {
    id: 9,
    title: "Enchanting Arunachal Pradesh",
    subtitle: "Guwahati – Dirang – Tawang – Bomdila",
    image: arunachal1,
    images: [arunachal1, arunachal2, arunachal3, arunachal4],
    overview: [
      [
        "Arunachal Pradesh, the ‘Land of the Rising Sun’, is a breathtaking destination known for its snow-clad mountains, serene monasteries, lush valleys, and rich tribal culture. From the scenic drives across high mountain passes to the spiritual calm of Tawang Monastery, this journey offers an immersive experience into untouched natural beauty and ancient traditions. Ideal for nature lovers, culture seekers, and adventure enthusiasts, Arunachal Pradesh promises a soulful and unforgettable Himalayan escape.🏔️",
      ],
    ],
    duration: "6 Nights / 7 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL IN GUWAHATI – TRANSFER TO DIRANG",
        details: [
          "Arrived at Guwahati Airport / Railway Station",
          " Meet and Greet on arrival",
          " Drive to Dirang",
          "*Approx 8-9 hours drive*",
          " Enroute visit Tipi Orchidarium",
          " Arrival in Dirang / Check in Hotel",
          " Overnight stay in Dirang",
        ],
      },
      {
        day: "02",
        title: "DIRANG – TAWANG",
        details: [
          " Breakfast at the Hotel",
          " Drive to Tawang",
          "*Approx 6-7 hours drive*",
          " Enroute cross Sela Pass (13,700 ft)",
          " Visit Sela Lake",
          " Visit Jaswant Garh War Memorial",
          " Arrival in Tawang / Check in Hotel",
          " Overnight stay in Tawang",
        ],
      },
      {
        day: "03",
        title: "TAWANG SIGHTSEEING",
        details: [
          " Breakfast at the Hotel",
          " Visit Tawang Monastery (Largest Monastery in India)",
          " Visit Urgelling Monastery (Birthplace of the 6th Dalai Lama)",
          " Visit Tawang War Memorial",
          " Evening free for local market",
          " Overnight stay in Tawang",
        ],
      },
      {
        day: "04",
        title: "TAWANG – BUM LA PASS (OPTIONAL)",
        details: [
          " Breakfast at the Hotel",
          " Excursion to Bum La Pass (subject to permit & weather)",
          " Visit Sangetsar Lake (Madhuri Lake)",
          " Return to Tawang",
          " Evening at leisure",
          " Overnight stay in Tawang",
        ],
      },
      {
        day: "05",
        title: "TAWANG – BOMDILA",
        details: [
          " Breakfast at the Hotel",
          " Drive to Bomdila",
          "*Approx 6-7 hours drive*",
          " Enroute scenic Himalayan views",
          " Arrival in Bomdila / Check in Hotel",
          " Visit Bomdila Monastery",
          " Overnight stay in Bomdila",
        ],
      },
      {
        day: "06",
        title: "BOMDILA – GUWAHATI",
        details: [
          " Breakfast at the Hotel",
          " Drive back to Guwahati",
          "*Approx 8-9 hours drive*",
          " Enroute scenic valleys and rivers",
          " Arrival in Guwahati / Check in Hotel",
          " Overnight stay in Guwahati",
        ],
      },
      {
        day: "07",
        title: "DEPART GUWAHATI",
        details: [
          " Breakfast at the Hotel",
          " Check out from Hotel",
          " Transfer to Guwahati Airport / Railway Station",
          " Departure with Lifetime Memories",
        ],
      },
    ],
    inclusions: [
      "Hotel Accommodation",
      "Daily Hotel Breakfast",
      "All transfers and sightseeing as per itinerary",
      "Inner Line Permit (ILP) assistance",
      "Driver allowance, tolls and parking",
    ],
    exclusions: [
      "Airfare / Train fare",
      "Bum La Pass permit & vehicle charges",
      "All personal expenses",
      "Meals not mentioned in the itinerary",
      "Camera / Video charges",
      "Travel Insurance",
      "5% GST and bank transfer charges",
    ],
  },

  //Mussoorie
  {
    id: 10,
    title: "Mussoorie & Rishikesh Retreat",
    subtitle: "Dehradun – Mussoorie – Rishikesh",
    image: mussoorie1,
    images: [mussoorie1, mussoorie2, mussoorie3, mussoorie4, mussoorie5],
    overview: [
      [
        "Mussoorie and Rishikesh together offer a perfect blend of serene hill-station charm and spiritual rejuvenation. Mussoorie, the ‘Queen of Hills’, is known for its pleasant climate, scenic viewpoints, waterfalls, and colonial-era charm. Rishikesh, nestled along the sacred River Ganga, is a global hub for yoga, meditation, and adventure activities. This journey combines nature, relaxation, spirituality, and light adventure, making it ideal for families, couples, and seekers of peace.🏔️🕉️",
      ],
    ],
    duration: "3 Nights / 4 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL IN DEHRADUN – TRANSFER TO MUSSOORIE",
        details: [
          "Arrived at Dehradun Airport / Railway Station",
          " Meet and Greet on arrival",
          " Drive to Mussoorie",
          "*Approx 1.5-2 hours drive*",
          " Check in Hotel",
          " Evening visit to Mall Road",
          " Overnight stay in Mussoorie",
        ],
      },
      {
        day: "02",
        title: "MUSSOORIE SIGHTSEEING",
        details: [
          " Breakfast at the Hotel",
          " Visit Kempty Falls",
          " Visit Gun Hill Point (by ropeway)",
          " Visit Camel’s Back Road",
          " Visit Lal Tibba",
          " Evening free for leisure",
          " Overnight stay in Mussoorie",
        ],
      },
      {
        day: "03",
        title: "MUSSOORIE – RISHIKESH",
        details: [
          " Breakfast at the Hotel",
          " Check out from Hotel",
          " Drive to Rishikesh",
          "*Approx 2.5-3 hours drive*",
          " Check in Hotel",
          " Visit Laxman Jhula & Ram Jhula",
          " Visit Parmarth Niketan Ashram",
          " Evening Ganga Aarti at Triveni Ghat / Parmarth Niketan",
          " Overnight stay in Rishikesh",
        ],
      },
      {
        day: "04",
        title: "DEPART RISHIKESH",
        details: [
          " Early morning Yoga / Meditation (optional)",
          " Breakfast at the Hotel",
          " Check out from Hotel",
          " Transfer to Dehradun Airport / Railway Station",
          " Departure with Refreshing Memories",
        ],
      },
    ],
    inclusions: [
      "Hotel Accommodation",
      "Daily Hotel Breakfast",
      "All transfers and sightseeing as per itinerary",
      "Driver allowance, tolls and parking",
    ],
    exclusions: [
      "Airfare / Train fare",
      "Adventure activities (rafting, bungee, etc.)",
      "All personal expenses",
      "Meals not mentioned in the itinerary",
      "Travel Insurance",
      "5% GST and bank transfer charges",
    ],
  },

  // Goa
  {
    id: 5,
    title: "Goa",
    subtitle:
      "North Goa - Coco Beach - Calangute Beach - Baga Beach - Anjuna Beach",
    image: goa1,
    images: [goa1, goa2, goa3, goa4, goa5],
    overview:
      "Goa tour offers a vibrant coastal experience with pristine beaches, historic architecture, and lively nightlife; the journey includes visits to iconic locations like Panaji, Calangute Beach, and Baga Beach, along with cultural attractions such as the Shri Shantadurga Temple and Old Goa Churches; perfect for beach lovers, couples, and those seeking a blend of relaxation and adventure.",
    duration: "2 Nights / 3 Days",
    itinerary: [
      {
        day: "01",
        title: "BANGALORE TO GOA",
        details: [
          "As you arrive at the Goa airport/railway station, an agent’s representative will receive you and escort you to the hotel. Complete-check-in formalities and relax for some time.",
          "Spend the entire first day of your Goa trip leisurely. Explore the sun-kissed beaches of Goa or try some amazing Goa delicacies like Goa fish curry.",
          "As you bid goodbye today one of your Goa holiday, come back to the hotel and have a goodnight’s sleep.",
          "Overnight stay at Hotel",
        ],
      },
      {
        day: "02",
        title: "EXPLORING THE BEACHES OF NORTH GOA CITY TOUR",
        details: [
          "Have breakfast and get ready to embark on a full-day North Goa sightseeing tour.",
          "The first attraction that you will visit on your North Goa tour is the ancient Fort Aguada.",
          "Later, explore Coco Beach, Calangute Annexe, Calangute Beach, Baga Beach and Anjuna Beach.",
          "As the second day of your Goa tour itinerary comes to an end, come back to the hotel and sleep off the night.",
          "Overnight stay at Hotel",
          "Meals: Breakfast",
        ],
      },
      {
        day: "03",
        title: "DEPARTURE",
        details: [
          "After Breakfast check out",
          "You depart with the memories of your tour arranged by M D TOURS AND TRAVELS",
        ],
      },
    ],
    inclusions: [
      "02 Night Accommodation at Goa with Breakfast",
      "All Tours and Transfers as per the Itinerary.",
      "All transfers using sedan vehicle",
      "Flight tickets one way",
    ],
    exclusions: [
      "Any expenses other than mentioned in the Inclusions",
      "Lunch & Dinner",
      "Entrance Fees not included",
    ],
  },

  // Golden Triangle 6N/7D Tour
  {
    id: 6,
    title: "Golden Triangle",
    subtitle: "Delhi - Agra - Jaipur",
    image: golden1,
    images: [
      golden2,
      golden3,
      golden4,
      golden5,
      golden6,
      golden7,
      golden8,
      rajasthan1,
      rajasthan2,
    ],
    overview:
      "Experience the magic of Bali with its stunning rice paddies, ancient temples, and vibrant art scene. Perfect for relaxation and adventure.",
    duration: "6 Nights / 7 Days",
    itinerary: [
      {
        day: "DAY 01",
        title: "ARRIVAL JAIPUR AND JAIPUR SIGHTSEEING",
        details: [
          "Arrive in Jaipur and proceed to Jaipur Local Sightseeing – Visit Birla Temple, Birla Auditorium and Albert Hall",
          "Lunch at outside restaurant (Own expenses)",
          "Later proceed to Visit Local Market and Nahargarh Fort (sunset view over city)",
          "Return back to hotel and Overnight Stay in Jaipur",
          "Meal Plan: Lunch + Dinner",
        ],
      },
      {
        day: "DAY 02",
        title: "JAIPUR LOCAL SIGHTSEEING",
        details: [
          "Breakfast at Hotel",
          "Proceed to excursion to Amber Fort and enjoy the elephant ride (Direct Pay)- See the largest cannon on wheels in the world, and old cannon foundry at Jaigarh.",
          "Visit to the KanakVrindavan Temple in the valley of flowers.",
          "Drive through the Johari Bazaar or the old jeweler's market to HawaMahal (Palace of Winds).",
          "Visit the various museums inside the City Palace and the ancient observatory and JantarMantar.",
          "Evening free for your independent activities and Return back to hotel and Overnight in Jaipur",
          "Meals – Breakfast + Lunch + Dinner",
        ],
      },
      {
        day: "DAY 03",
        title: "JAIPUR - FATEHPUR SIKRI - AGRA",
        details: [
          "After breakfast, check-out from hotel and proceed to Agra.",
          "En-route visit Fatehpur sikri, Buland darwaza (world largest Entrance gate).",
          "On arrival Agra. Check-in to hotel later visit The symbol of Love, the world famous monument Taj Mahal - the most precious gift of love built by Emperor Shah Jahan for his loving wife Mumtaz",
          "Overnight stay at Agra.",
          "Meals: Breakfast + Lunch + Dinner",
        ],
      },
      {
        day: "DAY 04",
        title: "AGRA TO DELHI (237 KM / 04 HR)",
        details: [
          "After breakfast check-out from hotel and proceed to Delhi.",
          "On arrival Delhi, proceed for local sightseeing, Chattapur Temple, Qutab Minar, Louts Temple, Hyumayun Tomb, Parliament House, Rashtrapati Bhawan, India Gate.",
          "Later check-in to hotel",
          "Overnight stay at Delhi.",
          "Meals: Breakfast + Lunch + Dinner",
        ],
      },
      {
        day: "DAY 05",
        title: "DELHI SIGHTSEEING",
        details: [
          "This morning post breakfast move out from hotel and proceed for Delhi sightseeing, visit Akshardham Temple, Raj Ghat, Red Fort, Jama Masjid, Daryaganj, Chandni Chowk.",
          "Overnight stay at Delhi.",
          "Meals: Breakfast + Lunch + Dinner",
        ],
      },
      {
        day: "DAY 06",
        title: "DEPARTURE TO BANGALORE",
        details: [
          "After Breakfast, drop at Airport.",
          "Arrive in Bangalore and proceed to Resort / Hotel",
          "Overnight stay in Bangalore",
          "Meals: Breakfast + Lunch + Dinner",
        ],
      },
      {
        day: "DAY 06",
        title: "DEPARTURE",
        details: [
          [
            "After Breakfast check-out from hotel and return home with sweet memories of your tour organized by",
            " ",
            <strong> M D TOURS AND TRAVELS.</strong>,
          ],
          "Meals: Breakfast",
        ],
      },
    ],
    inclusions: [
      "02 Night’s Accommodation in Delhi",
      "01 Night Accommodation in Agra",
      "02 Night’s Accommodation in Jaipur",
      "02 Night’s Accommodation in Bangalore",
      "Meals on Breakfast + Lunch + Dinner",
      "All the Tours and Transfers on A/C Coach",
      "Return Flight Fares Inclusive of Taxes",
      "Entrance Fees",
      "Sightseeing as per the Itinerary",
      "GST",
    ],
    exclusions: [
      "Guide Charges",
      "Personal Expenses other than mentioned in the Inclusions",
    ],
  },

  // Tamil Nadu Temples Tour 7N/8D Tour
  {
    id: 7,
    title: "Tamil Nadu Temple Tour",
    subtitle: "Bengaluru – Tamil Nadu Temples",
    image: tamil2,
    images: [tamil2, tamil3, tamil4, tamil5, tamil6],
    overview: [
      [
        "This curated Tamil Nadu Temple Tour from Bengaluru takes you through some of the most sacred and iconic temples in South India. The tour spans stunning Dravidian architecture, centuries-old spiritual sites, and famous divine destinations including Meenakshi Amman in Madurai, Ramanathaswamy in Rameswaram, Brihadeeswara in Thanjavur, and more. This journey offers a deep spiritual experience with cultural richness, temple darshan, and heritage exploration across Tamil Nadu.🙏🏽",
        "You can choose comfort travel by private car, coach, or special pilgrimage tour (e.g., IRCTC temple tour options covering Madurai, Rameswaram, and other temples).",
      ],
    ],
    duration: "5 Nights / 6 Days",
    itinerary: [
      {
        day: "01",
        title: "BENGALURU TO THANJAVUR",
        details: [
          "Depart from Bengaluru early morning",
          "Travel by private coach / car / train",
          "Arrive in Thanjavur – Check in Hotel",
          "Visit **Brihadeeswara Temple** (UNESCO World Heritage Site)",
          "Evening free for local temple visits",
          "Overnight stay in Thanjavur",
        ],
      },
      {
        day: "02",
        title: "THANJAVUR – KUMBAKONAM – RAMESWARAM",
        details: [
          "Breakfast at Hotel",
          "Drive to **Kumbakonam** — Visit Navagraha & other temples",
          "Continue to **Rameswaram**",
          "Check in Hotel",
          "Evening Darshan at **Ramanathaswamy Temple**",
          "Overnight stay in Rameswaram",
        ],
      },
      {
        day: "03",
        title: "RAMESWARAM TEMPLE TOUR",
        details: [
          "Early Morning Darshan at Ramanathaswamy Temple",
          "Visit **Navapashanam Temple** (Navagraha shrine in the sea):contentReference[oaicite:1]{index=1}",
          "Explore Dhanushkodi Beach area (optional)",
          "Return for evening Aarti",
          "Overnight stay in Rameswaram",
        ],
      },
      {
        day: "04",
        title: "RAMESWARAM – MADURAI",
        details: [
          "Breakfast at Hotel",
          "Drive to **Madurai**",
          "Check in Hotel",
          "Visit **Meenakshi Amman Temple** — One of South India’s most iconic temples",
          "Explore **Thirumalai Nayakar Palace** (optional)",
          "Overnight stay in Madurai",
        ],
      },
      {
        day: "05",
        title: "MADURAI – CHIDAMBARAM – PONDICHERRY / CHENNAI",
        details: [
          "Breakfast at Hotel",
          "Depart for **Chidambaram**",
          "Visit **Nataraja Temple** (Chidambaram)",
          "Drive onward to **Pondicherry / Chennai** for overnight",
          "Overnight stay in Pondicherry / Chennai",
        ],
      },
      {
        day: "06",
        title: "RETURN TO BENGALURU",
        details: [
          "Breakfast at Hotel",
          "Depart from Pondicherry / Chennai to Bengaluru",
          "Reach Bengaluru with Divine Memories",
        ],
      },
    ],
    inclusions: [
      "Hotel Accommodation as per itinerary",
      "Daily Breakfast",
      "All Transfers & Sightseeing as per itinerary",
      "Temple Darshan arrangements (where applicable)",
      "Driver allowance, tolls & parking",
    ],
    exclusions: [
      "Airfare / Train fare to/from Bengaluru",
      "Meals not mentioned above",
      "Pooja / Special Darshan charges at temples",
      "Personal expenses & tips",
      "Travel Insurance",
      "5% GST and bank charges",
    ],
  },

  // Andaman Islands 4N/5D Tour
  {
    id: 8,
    title: "Andaman Islands",
    subtitle: "Port Blair - Harbour Cruise - Havelock - Radhanagar Beach",
    image: andaman1,
    images: [andaman1, andaman2, andaman3],
    overview:
      "Andaman tour including Port Blair Harbour Cruise, Havelock Island, and Radhanagar Beach offers a perfect tropical escape with pristine white-sand beaches, turquoise waters, and lush island landscapes; experience the charm of the Port Blair Harbour Cruise with scenic ocean views, explore Havelock Island known for its laid-back vibe and water activities, and relax at the world-famous Radhanagar Beach celebrated for its breathtaking sunsets, making the journey an ideal blend of relaxation, adventure, and natural beauty.",
    duration: "4 Nights / 5 Days",
    itinerary: [
      {
        day: "01",
        title: "PORT BLAIR – HARBOUR CRUISE – LIGHT & SOUND SHOW",
        details: [
          "Our representative will receive from Port Blair airport and escort you to check-in to the hotel.",
          "After lunch, start the breathtaking trip to Cellular Jail- a place of pilgrimage for all freedom loving people,",
          "Carbyn’s cove Beach- one of the most picturesque, coconut palm fringed beaches which is 7 km from Port Blair.",
          "In the evening, enjoy the history of the heroic freedom struggle which is brought alive in a moving Light & Sound Show at Cellular Jail.",
          "Return back to hotel and Overnight stay in Port Blair",
          "Meal plan: Dinner",
        ],
      },
      {
        day: "02",
        title: "PORT BLAIR – HAVELOCK – RADHANAGAR BEACH",
        details: [
          "After breakfast, and finding your Test Report to be negative, board Makruzz / Green Ocean Cruise / Inter Island Ferry for Havelock Island.",
          "Our representative will receive from Havelock jetty and escort you to check-in to the hotel.",
          "After a little relaxation, proceed to the famous Radhanagar Beach which is rated #7 among the finest beaches in Asia.",
          "It is an ideal place for swimming, sea bathing and basking on the sun kissed beach",
          "Return back to hotel and Overnight stay in Havelock",
          "Meal plan: Breakfast and Dinner",
        ],
      },
      {
        day: "03",
        title: "VISIT KALAPATHAR BEACH OR OPTIONAL TOUR OF ELEPHANT BEACH",
        details: [
          "Breakfast from hotel",
          "Day at leisure",
          "Overnight stay in Havelock.",
          "Meal plan: Breakfast and Dinner",
          "Elephanta Beach is one of the most beautiful places in Havelock Island which is famous for its clear water and variety of live corals & colorful fishes.",
          "One can do several other water sports activities like Glass Bottom, Snorkeling, Banana Ride, Sofa Ride etc.)",
        ],
      },
      {
        day: "04",
        title: "HAVELOCK - PORT BLAIR",
        details: [
          "After breakfast, check out from the hotel and proceed to Havelock Jetty.",
          "After that, board Green Ocean Cruise / Makruzz / Inter Island Ferry and return to Port Blair.",
          "Evening is free for local marketing.",
          "Overnight stay at Port Blair.",
          "Meal plan: Breakfast and Dinner",
        ],
      },
      {
        day: "05",
        title: "PORT BLAIR – DEPARTURE",
        details: [
          "Check out early from hotel and then Proceed to Port Blair Airport",
          "Drop off at Airport for your return flight",
          "Tour Ends.",
          "Meal plan: Breakfast",
        ],
      },
    ],
    inclusions: [
      "02 nights’ accommodation in Port Blair",
      "02 nights’ accommodation in Havelock",
      "Meals on Breakfast and Dinner",
      "Return airport – hotel – airport transfers",
      "All transfers and sightseeing as per the itinerary",
      "Ferry tickets to Havelock & return to Port Blair.",
      "Entry Tickets for Cellular Jail, Light & Sound show",
      "Assistance at all arrival and departure points.",
      "24 Hour on call assistance during your stay.",
      "Round Flight Fares inclusive of Taxes",
      "Applicable all the taxes",
    ],
    exclusions: [
      "Lunch",
      "Personal Expenses",
      "Any other expenses not mentioned under the Inclusions",
      "Camera/video entrance fees",
    ],
  },

  // Lakshadweep Islands 4N/5D Tour
  {
    id: 9,
    title: "Lakshadweep Islands",
    subtitle: "Agatti Island - Bangaram Island - Shallow Lagoon",
    image: ld1,
    images: [ld1, ld2],
    overview:
      "Lakshadweep tour including Agatti Island, Bangaram Island, and the Shallow Lagoon offers an idyllic island getaway with pristine beaches, crystal-clear waters, and vibrant marine life; enjoy water sports, snorkeling, and scuba diving in the turquoise lagoons, relax on the untouched sandy shores of Agatti and Bangaram, and explore the tranquil Shallow Lagoon with its serene beauty, making the trip a perfect blend of adventure, relaxation, and breathtaking natural landscapes.",
    duration: "4 Nights / 5 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL AGATTI ISLAND",
        details: [
          "On arrival at Agatti airport, our representative will receive and escort you to the Hotel.",
          "After the lunch proceed for Agatti island sightseeing which include – Public Library, anthropological museum, South beach, Eastern jetty (ship embarkation and disembarkation point), NIOT sea water desalination Plant, Lagoon beach a sunset point, relax in the creamy sand for a couple of hours and back to Hotel around 7:00 pm, dinner will be serve at 8:30 pm.",
          "Overnight stay at Agatti.",
        ],
      },
      {
        day: "02",
        title: "AGATTI – SOUTH BEACH FOR WATER SPORTS ACTIVITIES",
        details: [
          "Morning after breakfast proceed to South Beach, nonstop water sports available at the beach, like swimming, snorkeling, kayaking, well equipped SCUBA diving center working at beach which offers Snorkeling, Kayaking, Diving, Glass bottom boat ride on payment.",
          "Guidance of well experienced diving instructor you can enjoy the underwater beauty.",
          "Lunch will be served at the beach on request.",
          "After 4 PM back to Hotel / and relax Hotel/ round, relax in room, dinner will be served at 8:30.",
          "Overnight stay at Agatti.",
        ],
      },
      {
        day: "03",
        title: "AGATTI – BANGARAM  THINAKARA ISLAND DAY TRIP BY PRIVATE BOAT",
        details: [
          "Early morning after breakfast proceeds to Bangaram group of islands beautiful uninhabited island , Bangaram, Tinnakara island , in a single atoll, lying in the northern side of Agatti.",
          "Tour by a private boat from Agatti 45 minutes Journey.",
          "Trip provides beautiful sandy beaches and swimming with turtles, snorkeling in blue shallow water.",
          "After Bangaram sightseeing, boat moves to Thinnakara island , after 5 pm boat moves to Agatti Hotel, relax in room, dinner will be served at 8:30 pm.",
          "Please note movement of the boat to Thinnakara depends on high tide and low tide of sea level",
          "Overnight stay at Agatti.",
        ],
      },
      {
        day: "04",
        title: "ACTIVITIES IN SHALLOW LAGOON",
        details: [
          "After Morning breakfast, enjoy the Glass bottom boating in the lagoon for 1 hour, nonstop water sports available at the beach, like swimming, snorkelling, kayaking up to 12 PM.",
          "Lunch will be served at 1 PM.",
          "After 4:30 pm proceed to Kalpitti island , a small islet in the southern tip of Agatti , which offer swimming and turtle watch, The journey by a small boat in shallow water, sightseeing in the island by walk, after sightseeing Kalpitti island return to Agatti around 6:30 pm.",
          "Overnight stay at Agatti.",
        ],
      },
      {
        day: "05",
        title: "ENJOY THE SANDY BEACH BAREFOOT WALK",
        details: [
          "Enjoy the sandy beach barefoot walk and leisure time at Agatti.",
          "Check out and proceed to Agatti Airport for your return flight.",
          "Tour Ends.",
        ],
      },
    ],
    inclusions: [
      "04 Nights Accommodation",
      "Daily Breakfast",
      "All transfers as per the itinerary",
      "Sightseeing as per the itinerary",
      "Local guide services at Islands",
      "Ferry/Boat transfers as mentioned",
    ],
    exclusions: [
      "Lunch",
      "Personal Expenses",
      "Water Sports charges where applicable",
      "Any other services not mentioned in inclusions",
    ],
  },

  // Gujarat 8N/9D Tour
  {
    id: 9,
    title: "Gujarat",
    subtitle: "Ahmedabad - Dwarka - Somnath - Diu - Sasangir - Vadodara",
    image: gujarat1,
    images: [
      gujarat1,
      gujarat2,
      gujarat3,
      gujarat4,
      gujarat5,
      gujarat6,
      gujarat7,
    ],
    overview:
      "Gujarat tour offers a vibrant journey through rich heritage, spiritual landmarks, and diverse landscapes, featuring iconic attractions like the Statue of Unity, Gir National Park, Rann of Kutch, and sacred temples of Somnath and Dwarka; experience colorful culture, traditional handicrafts, wildlife safaris, stunning white salt desert views, and flavorful Gujarati cuisine, making the trip a perfect blend of history, spirituality, nature, and cultural exploration.",
    duration: "8 Nights / 9 Days",
    itinerary: [
      {
        day: "01",
        title: "AHMEDABAD",
        details: [
          "Ahmedabad starting your day.",
          "Places to visit at Gandhinagar, Sabarmati Ashram, Sardar Vallabhai Patel national Memorial (close on Monday) Adalaj Stepwell, Swaminarayan Akshardham temple (close on Monday).",
          "Overnight stay at Ahmedabad",
        ],
      },
      {
        day: "02",
        title: "AHMEDABAD – PORBANDAR – DWARKA",
        details: [
          "Morning after breakfast will drive to Dwarka.",
          "En route will visit kirti temple at Porbandar.",
          "Reaching at Dwarka would undoubtedly raise a sensation of Lord Krishna everywhere in your environment.",
          "The first place to visit is the Dwarkadhish Temple moving forward to Nageshwar Jyotirlinga Temple and Nageshwar Shiva Temple.",
          "Return back to hotel and overnight stay.",
        ],
      },
      {
        day: "03",
        title: "DWARKA – BET DWARKA – DWARKA",
        details: [
          "Starting fresh on the Devabhoomi you would then start travelling for Bhait Dwarika a journey by road and crossing the sea you reach at the beautiful place of lord Krishna.",
          "You also won’t miss out from the places like Rukshamanee Mandir, Gomti Ghat, Bhadkeshwar Mahadev Mandir, Sudama Setu (Sudama Bridge), Shri Swaminarayan Mandir, Dwarka and Gopi Talab.",
          "After that will drive to Somnath.",
        ],
      },
      {
        day: "04",
        title: "DWARKA – SOMNATH",
        details: [
          "Arriving at Somnath you would undergo a strange feeling of devotedness towards the Lord Shiva who is known as Mahadev i.e. Lord of the Lords in Hindu religion.",
          "The first place in Somnath you would visit is the Grand Somnath Temple situated by the side of sea.",
          "You cannot deny your amazement by seeing the chalukyan art and architecture of the temple.",
          "Overnight stay at Somnath.",
        ],
      },
      {
        day: "05",
        title: "SOMNATH – DIU",
        details: [
          "Morning after breakfast visit Bhalika Tirth & Triveni Ghat.",
          "Later drive to Diu, visit Diu: A beautiful blend of sun, sand and sea, Diu is a God's gift to those in quest of a blessed land where the weary weight of this unintelligible world can, for a while, be lightened and the waking soul can hear the music of the nature.",
          "This tiny island of breeze, beauty and serenity situated off the southern tip of the Saurashtra (Kathiawad) peninsula of Gujarat, lapped by the Arabian Sea, is a picture of calmness with superb beaches and a fascinating history.",
          "Diu was ruled by many well-known kings and dynasties during the prehistoric, ancient and medieval times. It was a Portuguese colony until 1961. It is now a Union Territory, separated from Goa in 1987.",
          "In the late afternoon you will proceed to visit the St. Paul’s church, Diu Fort & markets.",
          "Overnight stay at Diu.",
        ],
      },
      {
        day: "06",
        title: "DIU – SASANGIR",
        details: [
          "Morning after breakfast proceeds to Sasangir, Sasan Gir Lion sanctuary is home of some 300 Asiatic Lions.",
          "Sasan Gir is only place in world outside African continent where lion can be seen in its natural habitat.",
          "Gir Wild life Sanctuary is the last refuge of Asiatic lions in India and the lion population residing in the park is a little over 300.",
          "Gir is not just about Lions, the second most commonly found predator in the Gir is Leopard.",
          "OVER N I G H T stay at Sasangir.",
        ],
      },
      {
        day: "07",
        title: "SASANGIR – VADODARA",
        details: [
          "After breakfast, proceed to Vadodara.",
          "Visit Statue of Unity - the world's tallest statue, Narmada Dam, and Poicha Temple.",
          "Return to Vadodara & Overnight stay at the hotel.",
        ],
      },
      {
        day: "08",
        title: "VADODARA – AHMEDABAD",
        details: [
          "Morning after breakfast visit Akshardham Temple (Monday Closed).",
          "Sidi Sayed mosque, built in 1573, is one of the most famous mosques of Ahmadabad.",
          "Gandhi Ashram The beautiful ashram complex of Ahmadabad, with shady trees populated by thousand of parakeets, Beaters, sunbirds, squirrels, offers a refuge from the loud streets of the city and is one of the foremost tourist attraction of Ahmadabad.",
          "This ashram was Gandhi’s head quarters during the long struggle for Indian independence.",
        ],
      },
      {
        day: "09",
        title: "DEPARTURE",
        details: [
          "After breakfast, checkout and proceed to airport for departure.",
        ],
      },
    ],
    inclusions: [
      "02 nights accommodation in Ahmedabad",
      "02 nights accommodation in Dwarka",
      "01 night accommodation in Somnath",
      "01 night accommodation in Diu",
      "01 night accommodation in Sasangir",
      "01 night accommodation in Vadodara",
      "Meal plan on MAP (Breakfast + Dinner)",
      "Vehicle for 09 days (Etios or Swift Desire)",
      "Round flight tickets",
      "Tours and transfers as per the itinerary",
      "Applicable all the Taxes",
    ],
    exclusions: [
      "Lunch",
      "Personal expenses",
      "Entrance Fee",
      "The Statue of Unity & other tickets.",
      "Gir Safari Permit at Sasan Gir.",
      "Jeep & Tour Guide Charges at Sasangir for Gir Safari (Directly payable by the Guest at the Spot only)",
      "Tips",
      "Early check in or late check-out charges.",
      "Any other expense not mentioned in the inclusions",
    ],
  },

  // Mahabaleshwar & Lonavala 4N/5D Tour
  {
    id: 9,
    title: "Mahabaleshwar & Lonavala",
    subtitle: "Mahabaleshwar - Venna Lake - Lonavala - Tiger's Leap",
    image: lonavala1,
    images: [lonavala1, lonavala2, lonavala3, lonavala4],
    overview:
      "Experience the charm of Mahabaleshwar and Lonavala with their scenic landscapes, serene lakes, and lush greenery; enjoy boating in Venna Lake, explore viewpoints like Arthur's Seat and Tiger's Leap, and indulge in local delicacies like strawberries and chikki, making it a perfect getaway for nature lovers and adventure seekers alike.",
    duration: "4 Nights / 5 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL IN PUNE AIRPORT",
        details: [
          "Meet our representative at Pune airport, transfer to Mahabaleshwar",
          "On Arrival to Mahabaleshwar and proceed to check-in at Hotel.",
          "Visit iconic viewpoints like Arthur's Seat, Kate's Point, and Elephant's Head Point for stunning vistas",
          "Overnight stay in Mahabaleshwar.",
        ],
      },
      {
        day: "02",
        title: "MAHABALESHWAR SIGHTSEEING",
        details: [
          "After your Breakfast, proceed to Mahabaleshwar +Sightseeing",
          "Wilson Point, Mahabaleshwar Temple, Elphinstone Point, Pratapgad Fort, Lingmala Falls, Helen’s Point.",
          "Back to Hotel for Overnight stay",
        ],
      },
      {
        day: "03",
        title: "MAHABALESHWAR TO LONAVALA",
        details: [
          "Today after your Breakfast, check-out from hotel and drive to Lonavala.",
          "On arrival proceed to visit - Visit Redwood Park & Shivaji Udyan.",
          "The Valvan Dam and Tungarli Lake is a must visit place for you.",
          "Rajmachi Point is a historical point located at the Western Ghats which is the most popular destination for the hikers and trekkers.",
          "Later check-in to hotel for Overnight stay.",
        ],
      },
      {
        day: "04",
        title: "LONAVALA SIGHTSEEING",
        details: [
          "Today after breakfast proceed for half day Lonavala Sightseeing.",
          "You can explore Tiger’s Leap and Amruntanjan Point.",
          "The Bhushi Lake and Khandala Lake are the most visited place of Khandala.",
        ],
      },
      {
        day: "05",
        title: "PUNE - DEPARTURE",
        details: [
          "Today after breakfast, you will be transferred back to Pune airport for your onward journey.",
          "Return home with beautiful memories of Mumbai tour package which will be with you for life long.",
        ],
      },
    ],
    inclusions: [
      "02 Night’s Accommodation in Mahabaleshwar",
      "02 Night’s Accommodation in Lonavala",
      "Daily Breakfast",
      "Vehicle for 05 Days",
      "Return flight fare",
      "AC Not applicable in Hilly areas",
      "Inclusive of all taxes, (Parking, Toll, Fuel Expenses & Driver’s Bata)",
      "All sightseeing covered as per the itinerary.",
    ],
    exclusions: [
      "Lunch & Dinner not included",
      "Any Monument Entrance or any activity Fee",
      "Expenses of personal nature like drinks, personal insurance, tips and telephone calls.",
      "Any additional expenses due to unforeseen problems like natural disaster, war or strikes, cancellation or misconnection of flight or last minute change of timings etc.",
      'Any other service, which has not been specified as "included".',
    ],
  },

  // Sikkim & Darjeeling 5N/6D Tour
  {
    id: 9,
    title: "Sikkim & Darjeeling",
    subtitle: "Gangtok - Tsomgo Lake - Pelling - Darjeeling",
    image: sikkim1,
    images: [sikkim1, sikkim2, sikkim3, sikkim4, sikkim5],
    overview:
      "Experience the serene beauty of Sikkim and Darjeeling with breathtaking views of the Himalayas, tranquil lakes, and vibrant culture; visit iconic spots like Tsomgo Lake, Baba Mandir, and Tiger Hill, indulge in local cuisine, and explore tea gardens, making it a perfect blend of nature, spirituality, and adventure for travelers seeking a peaceful retreat amidst the mountains. ",
    duration: "5 Nights / 6 Days",
    itinerary: [
      {
        day: "01",
        title: "IXB AIRPORT – GANGTOK (140 KMS / 05 – 06 HRS)",
        details: [
          "Upon arrival at Bagdogra Airport meet & greet, then transfer to Gangtok.",
          "On arrival at Gangtok, check-in to hotel & enjoy rest of the day at leisure.",
          "Lunch on the way to Gantok. (on your own)",
          "Enjoy overnight stay in Gangtok.",
        ],
      },
      {
        day: "DAY 02",
        title: "GANGTOK - TSOMGO LAKE & BABA MANDIR – GANGTOK (55 KMS ONE WAY)",
        details: [
          "After a delicious breakfast at hotel visit Tsomgo Lake (12,400 ft.) & Baba Mandir (13,200 ft.) which is 55 kms one way from Gangtok city.",
          "Enjoy the evening at leisure - Shop around at M.G. Marg & explore the city on your own.",
          "Enjoy overnight stay in Gangtok.",
          "VISIT TO NATHULA PASS (14450FT) INCLUDED:",
          "The road to Nathula passes through the Tsomgo lake.",
          "It is one of the highest motorable roads in the world and is richly surrounded by alpine flora.",
          "On a clear day you can even see the road winding down the Chumbi valley.",
          "Tourists are allowed to go close to the international border from where you can see Chinese soldiers on the other side of the barbed wire.",
          "Nathula is open for Indian nationals on Wednesday, Thursday, Friday, Saturday and Sundays.",
          "(Rs.5500 /- Vehicle Extra to Visit Nathula Pass).",
          "(If due to landslide or bad road condition Tsomgo Lake is closed then alternate sightseeing will be provided)",
        ],
      },
      {
        day: "DAY 03",
        title: "GANGTOK SIGHTSEEING – PELLING (120 KMS / 05 HRS)",
        details: [
          "After enjoying breakfast start for a half day trip of Gangtok city, covering Ranka Monastery Banzakhri Falls, Cottage Industry and Handicraft Centre, Flower show, Dro-dul Chorten & Institute of Tibetology (maximum 3-4 hours).",
          "After the sightseeing of Gangtok, drive to Pelling.",
          "Enjoy overnight stay in Pelling.",
        ],
      },
      {
        day: "DAY 04",
        title: "PELLING SIGHTSEEING - DARJEELING",
        details: [
          "After a delightful breakfast start for full day sightseeing",
          "In 1st Half tour - Darap village, Rimbi water Falls, Sewaro Rock Garden, Khecheopalri Lake & Khangchendzongha waterfalls.",
          "In afternoon start for 2nd half tour - Pemayangtse Monastery, Rabdantse Ruins, New Halipad Ground.",
          "Spend the evening at leisure.",
          "Enjoy overnight stay in Pelling.",
        ],
      },
      {
        day: "DAY 05",
        title: "DARJEELING LOCAL SIGHTSEEING (10 POINTS)",
        details: [
          "Be a witness of the spectacular sunrise over Mt. Kangchenjunga (28,208 ft. Worlds 3rd highest peak at around 4 am) at Tiger Hill early in the morning (subject to permit & weather conditions).",
          "After a sumptuous breakfast thrill yourself by visiting World famous Ghoom Monastery and Batasia Loop.",
          "Also visit Himalayan Mountaineering Institute, P.N. Zoological Park (Thursday closed), Tenzing Rock, Tibetan Refugee self-help Centre (Sunday closed), Tea Garden (outer view), Japanese Temple, Peace Pagoda and Ropeway (Ticket cost not included and directly payable by guest).",
          "In evening, explore the Mall on your own & shop around.",
          "Enjoy overnight stay in Darjeeling.",
        ],
      },
      {
        day: "DAY 06",
        title: "DEPARTURE",
        details: [
          "After breakfast checkout and proceed to the airport.",
          "Tour Ends",
        ],
      },
    ],
    inclusions: [
      "05 Nights’ Accommodation",
      "Meal Plan on Breakfast & Dinner",
      "Vehicle for 06 Days",
      "Tours and Transfers on Private basis",
      "Sightseeing as per the Itinerary",
      "Return Flight fares inclusive of taxes",
      "GST",
    ],
    exclusions: [
      "Any expenses not mentioned under the Inclusions",
      "Lunch",
      "Entrance fees not included",
    ],
  },

  //Karnataka Heritage Tour 7N/8D Tour
  {
    id: 9,
    title: "Karnataka Heritage Tour",
    subtitle: "Gangtok - Tsomgo Lake - Pelling - Darjeeling",
    image: kar1,
    images: [
      kar1,
      kar2,
      kar3,
      kar4,
      kar5,
      kar6,
      kar7,
      kar8,
      kar9,
      kar10,
      kar11,
      kar12,
    ],
    overview:
      "Explore the rich heritage of Karnataka with its magnificent palaces, ancient temples, and vibrant culture; visit iconic sites like Mysore Palace, Coorg's scenic landscapes, Dharmasthala's spiritual temples, and the historic towns of Sringeri and Gokarna, making it a perfect blend of history, spirituality, and natural beauty for travelers seeking an immersive cultural experience in southern India.",
    duration: "7 Nights / 8 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL + BANGALORE SIGHTSEEING",
        details: [
          "On arrival to Bangalore, pick up by our representative and proceed to Bangalore sightseeing.",
          "Visit Iskcon Temple, Bull Temple, Tipu Sultan Palace, Lalbagh Botanical Garden, Vishveshwarya Technological Museum Vidhana Souda.",
          "Later get transferred to Mysore.",
          "Overnight stay in Mysore.",
        ],
      },
      {
        day: "02",
        title: "MYSORE + SIGHTSEEING",
        details: [
          "After breakfast proceed for full day Mysore sightseeing, you will visit Chamundi hills.",
          "Chamundi Hills is the prime landmark of Mysore city, visible almost from anywhere in the city.",
          "Later explore the Mysore Zoo, one of the oldest Zoo’s of India.",
          "Mysore Palace, one of the largest palaces in the country.",
          "In the evening enjoy the light show, water dance in Brindavan Gardens, which is spread across an area of 60 acres, at the bottom of the Krishnaraja Sagara Dam (KRS), across the river Cauvery.",
          "Overnight stay in Mysore.",
          "Meal Plan – Breakfast",
        ],
      },
      {
        day: "03",
        title: "MYSORE – MADIKERI + COORG SIGHTSEEING",
        details: [
          "Welcome to Scotland of India, after your breakfast at hotel, check-out hotel & proceed for Sightseeing of Coorg.",
          "Sightseeing includes - Omkareshwara temple, Abbey falls, kote abbe falls Tibetian Monastery / Golden Temple.",
          "This Place is one of the largest Tibetan settlements in India.",
          "There are around 16000 refugees and nearly 6000 monks and nuns in this monastery.",
          "Nisargadhama Forest Park, an island formed by the River Kaveri.",
          "Dubare Elephant Camp, a forest camp on the banks of the river Cauveri.",
          "Later get transferred to Madikeri, Rest of the day for leisure.",
          "Overnight stay in Madikeri.",
        ],
      },
      {
        day: "04",
        title: "MADIKERI – DHARMASTHALA - ENROUTE KUKKE",
        details: [
          "After breakfast, check out the hotel and proceed to dharmasthala enroute kukke.",
          "Arrive at Kukke visit the main temple of Kukke Shri Subranhmanya Swamy Temple.",
          "After kukke, transfer to dharmasthala, enroute Southadka and visit the temple of southadka ganapathi temple.",
          "Later transfer to dharmasthala.",
          "Arrive at dharmasthala visit the main temple and check into hotel.",
          "Overnight stay in dharmasthala.",
        ],
      },
      {
        day: "05",
        title: "DHARMASTHALA – SRINGERI ENROUTE BELUR & HORNADU",
        details: [
          "After breakfast, check out the hotel and proceed to Sringeri enroute Belur & Hornadu.",
          "Arrive at Belur visit the main temple of Shri Chennakeshava Swami Temple Beluru.",
          "After Belur, transfer to Sringeri, enroute Hornadu and visit the temple of horanadu annapoorneshwari temple.",
          "Later transfer to Sringeri.",
          "Arrive at Sringeri visit the main temple and check into hotel.",
          "Overnight stay in Sringeri.",
        ],
      },
      {
        day: "06",
        title: "SRINGERI – MURDESHWARA – ENROUTE UDUPI & KOLLUR",
        details: [
          "After breakfast, check out the hotel and proceed to Murdeshwara enroute Udupi & kollur.",
          "Arrive at Udupi visit the main temple of Krishna Temple Udupi, and visit Malpe beach.",
          "After Udupi, transfer to Murdeshwara, enroute Kollur and visit the temple of kollur mookambika.",
          "Later transfer to Murdeshwara.",
          "Arrive at Murdeshwara visit the main temple and check into hotel.",
          "Overnight stay in Murdeshwara.",
        ],
      },
      {
        day: "07",
        title: "MURDESHWARA – GOKARNA",
        details: [
          "After breakfast, check out the hotel and proceed to Gokarna.",
          "Arrive at Gokarna visit the main temple of Shri Mahabaleshwara Swamy Temple (Gokarna).",
          "Visit Gokarna Main Beach, Mirjan Fort.",
          "Later check into hotel.",
          "Overnight stay in Gokarna.",
        ],
      },
      {
        day: "08",
        title: "GOKARNA - BANGALORE",
        details: [
          "After your Breakfast, check-out from hotel and drive to Bangalore, with the great memories of your tour organized by M D TOURS AND TRAVELS.",
        ],
      },
    ],
    inclusions: [
      "02 Night accommodation in Mysore",
      "01 Nights’ accommodation in Madikeri",
      "01 Nights’ accommodation in Dharmasthala",
      "01 Nights’ accommodation in Sringeri",
      "01 Nights’ accommodation in Murdeshwara",
      "01 Nights’ accommodation in Gokarna",
      "Meal plan on Breakfast Basis",
      "Tours and Transfers as itinerary",
      "Inclusive of all taxes",
      "Air fare",
    ],
    exclusions: [
      "Personal expenses",
      "Lunch & Dinner not included",
      "Entrance Tickets & Ticket for other activities",
      "Any other expense not mentioned in the inclusions",
    ],
  },
];

export default domestic;
